import React from 'react';
import { AuthorizedView, Roles } from 'components/Utilities/AuthorizedView';
import Button from 'components/Button/Button';
import { RETOOL_SPOT_FORM_URL } from 'utils/constants';

type AddSpotProps = {
    organizationId: string | number;
};

function AddSpot({ organizationId }: AddSpotProps): JSX.Element {
    return (
        <AuthorizedView allowed={Roles.Superuser}>
            <Button
                onClick={() => window.open(`${RETOOL_SPOT_FORM_URL}?org=${organizationId}`, '_blank')}
                style={{ maxWidth: '200px' }}
            >
                Add Spot
            </Button>
        </AuthorizedView>
    );
}

export default AddSpot;
